var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('Card',[_c('template',{slot:"header"},[_c('h3',[_vm._v("فاکتورهای من")])]),_c('template',{slot:"content"},[_c('Factor-Manager')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }